import { render, staticRenderFns } from "./SignUpFree.vue?vue&type=template&id=28369074"
import script from "./SignUpFree.vue?vue&type=script&lang=js"
export * from "./SignUpFree.vue?vue&type=script&lang=js"
import style0 from "./SignUpFree.vue?vue&type=style&index=0&id=28369074&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports